<template>
	<v-card-title v-if="title" class="d-flex align-center">
		{{ title }}
		<v-icon color="info" @click="load">$reload</v-icon>
	</v-card-title>
	<v-card-text>
		<v-form @submit.prevent="search" class="form-inline">
			<v-row class="">
				<v-col cols="12" class="d-flex flex-wrap align-center">
					<v-text-field
						outlined
						dense
						v-model="query.title"
						label="标题"
						hide-details
						class="search-field-name mr-1"
					/>
					<v-select
						outlined
						dense
						label="状态"
						v-model="query.status"
						:items="refs['PageStatus']"
						hide-details
						class="mr-1"
						clearable
					></v-select>
					<v-btn color="primary" @click="search" class="mr-1">
						<v-icon>$search</v-icon>
						查询
					</v-btn>
					<v-icon v-if="queryPairs.length > 0" class="mr-1" @click="reset">$close</v-icon>
				</v-col>
			</v-row>
		</v-form>
	</v-card-text>
	<v-data-table-server
		:headers="headers"
		:items="objects"
		:items-length="parseInt(total)"
		:loading="loading"
		:show-select="showSelect"
		:single-select="singleSelect"
		v-model="selected"
		multi-sort
	>
		<template v-slot:top>
			<slot name=" batchActions" v-bind:selected="selected"></slot>
		</template>
		<template v-slot:item.status="{ item }">
			{{ item.status }}
		</template>
		<template v-slot:item.title="{ item }">{{ item.title }}</template>
		<template v-slot:item.code="{ item }">{{ item.code }}</template>
		<template v-slot:item.author="{ item }">{{ item.author }}</template>
		<template v-slot:item.category_path="{ item }">{{ item.category_path }}</template>
		<template v-slot:item.action="{ item }">
			<slot name="actions" v-bind:item="item"></slot>
		</template>

		<template v-slot:footer>
			<slot name="batchActions" v-bind:selected="selected"></slot>
		</template>
	</v-data-table-server>
</template>

<script>
import { clone, valuesIn, toPairsIn, filter, intersection } from 'lodash-es'
import qs from 'qs'

export default {
	components: {},
	props: {
		initQuery: { type: Object, default: null },
		title: { type: String, default: null },
		showSelect: { type: Boolean, default: false },
		singleSelect: { type: Boolean, default: true },
		headers: {
			type: Array,
			default: () => [
				{ title: '#', value: 'id' },
				{ title: '标题', align: 'left', sortable: true, value: 'title' },
				{ title: '编码', value: 'code' },
				{ title: '作者', value: 'author' },
				{ title: '状态', value: 'status' },
				{ title: '分类', value: 'category_path' },
				{ title: '', align: 'left', sortable: false, value: 'action' }
			]
		}
	},
	data() {
		const qps = qs.parse(location.search, { ignoreQueryPrefix: true })
		return {
			query: qps,
			currentQuery: {}, //当前结果的查询条件
			objects: [],
			total: 0,
			loading: false,
			options: {},
			refs: {},
			selected: [],
			errors: {}
		}
	},
	mounted() {
		if (this.initQuery) {
			this.query = clone(this.initQuery)
		}
		this.$api.common.meta('page', 'PageStatus,PageType', (res) => {
			this.refs = res
		})
	},
	computed: {
		queryValues() {
			return filter(valuesIn(this.query), (e) => !!e)
		},
		currentQueryValues() {
			return filter(valuesIn(this.currentQuery), (e) => !!e)
		},
		queryPairs() {
			return filter(toPairsIn(this.query), (e) => !!e[1])
		}
	},
	watch: {},
	methods: {
		search() {
			if (
				this.queryValues.length !== this.currentQueryValues.length ||
				intersection(this.queryValues, this.currentQueryValues).length !== this.queryValues.length
			) {
				//条件变化
				if (this.options.page === 1) {
					//当前如果是第一页，手动触发
					this.load()
				} else {
					this.options.page = 1 //当前不是第一页，修改后通过watcher触发
				}
			} else {
				//条件没变，忽略
			}
		},
		reset() {
			this.query = {}
		},
		load(options = null) {
			if (!this.options) this.options = {}
			if (options) {
				this.options = options
			}

			let { sortBy, page, itemsPerPage } = this.options
			this.loading = true
			let qwp = clone(this.query)
			qwp.pageno = page
			qwp.pagesize = itemsPerPage
			qwp.sortBy = 'updated_at'
			qwp.sortDesc = 'desc'
			if (sortBy && sortBy.length > 0) {
				qwp.sort = sortBy.map((e) => `${e.key} ${e.order}`).join(',')
				qwp.sortBy = sortBy[0]['key']
				qwp.sortDesc = sortBy[0]['order']
			}
			this.currentQuery = clone(this.query)

			this.$api.page.search(qwp, (response) => {
				this.objects = response.objects
				this.total = response.total
				this.loading = false
			})
		}
	}
}
</script>

<style scoped>
.silent td {
	color: rgba(3, 3, 3, 0.5) !important;
}
</style>
